import { Configuration } from 'types/configuration'
import Api from './axiosInstance'
import { API_CONFIG as AC, API_CONFIG, API_CRON } from 'utils/constants'

// get site configurations
const fetchConfigurations = () => {
  return Api.get({ url: AC.CONFIG })
}

// updates site configurations
const updateConfigurations = (id: string, data: Configuration) => {
  return Api.patch({ url: `${AC.CONFIG}/${id}`, data })
}

// create the site configuration for first time
const createConfigurations = (data: Configuration) => {
  return Api.post({ url: AC.CONFIG, data })
}

// Initiate the master data manual cron
const initiateMasterDataCronManual = (lastUpdatedDateTime: string) => {
  return Api.post({ url: API_CRON.CRON_MASTER, data: { lastUpdatedDateTime } })
}

// Initiate the Inventory manual cron
const initiateInventoryCronManual = (lastUpdatedDateTime: string) => {
  return Api.post({
    url: API_CRON.CRON_INVENTORY,
    data: { lastUpdatedDateTime },
  })
}

// Initiate the Pricing manual cron
const initiatePricingCronManual = () => {
  return Api.post({ url: API_CRON.CRON_PRICING })
}

const syncAggregatorCron = () => {
  return Api.post({ url: API_CRON.CRON_SYNC_AGG })
}

const getRmaConfigurations = () => {
  return Api.get({ url: API_CONFIG.RMA })
}

export {
  getRmaConfigurations,
  syncAggregatorCron,
  fetchConfigurations,
  updateConfigurations,
  createConfigurations,
  initiateMasterDataCronManual,
  initiateInventoryCronManual,
  initiatePricingCronManual,
}
